import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@root/globalTypes';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { PresetsRespSuccess } from '../types';
import { usePanelUrl } from '../helpers';
import { useParams } from 'react-router';

export const useGetPresets = () => {
  const { tenantId } = useParams();
  const opt = usePanelUrl('dashboards');

  const { data, error, isPending } = useQuery<PresetsRespSuccess, ApiError>({
    queryKey: [...queryKeys.dashboards.index, tenantId],
    queryFn: () => queryFetch(opt),
    placeholderData: (previousData) => previousData as PresetsRespSuccess,
  });

  return {
    data,
    error,
    isLoading: isPending,
  };
};
